import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { Arrow} from "../../icons"

const PageBanner = ({ title, image, richContent, subtitle, link }) => {

  return (
    <section className="page-banner">
      <div className="page-banner__inner">
        {image && <Asset className="page-banner__bg" asset={image} />}
        <div className='page-banner__content'>
          <div className='page-banner__left'>
            {subtitle && <span>{parse(subtitle)}</span>}
            {title && <h2>{parse(title)}</h2>}
          </div>
          { richContent &&
            <div className='page-banner__right'>
              {richContent && <StructuredText data={richContent} />}
              {
                link?.length > 0 &&
                <Link
                  to={link[0]?.link[0].externalLink ? link[0]?.link[0].externalLink : link[0]?.link[0].internalLink.permalink}
                >
                  <Arrow/>
                </Link>
              }
            </div>
          }
        </div>
      </div>
    </section>
  )
}

export default PageBanner

export const query = graphql`
fragment PageBannerProps on DatoCmsPageBanner {
  ... on DatoCmsPageBanner {
    id
    image {
      ...InternalAssetProps
    }
    title
    subtitle
    link {
      ...LinkWithTitleProps
    }
    richContent {
      value
    }
  }
}
`